import { useState, useEffect } from 'react';

/**
 * Custom hook for managing table preferences (rows per page, table density)
 * Listens to preference changes from Navbar and syncs with localStorage
 * Also listens for localStorage changes from other tabs
 * @returns {object} Object containing rowsPerPage, tableDensity, activePage, and setActivePage
 */
export const useTablePreferences = () => {
    const [rowsPerPage, setRowsPerPage] = useState(() => 
        parseInt(localStorage.getItem('tb_rowsPerPage') || '25', 10)
    );
    const [tableDensity, setTableDensity] = useState(() => 
        localStorage.getItem('tb_tableDensity') || 'comfortable'
    );
    const [activePage, setActivePage] = useState(1);

    // Listen for preference changes (from same tab - custom event)
    useEffect(() => {
        const handler = (e) => {
            if (e.detail?.rowsPerPage) setRowsPerPage(parseInt(e.detail.rowsPerPage, 10));
            if (e.detail?.tableDensity) setTableDensity(e.detail.tableDensity);
            setActivePage(1);
        };
        window.addEventListener('tb:prefsChanged', handler);
        return () => window.removeEventListener('tb:prefsChanged', handler);
    }, []);

    // Listen for localStorage changes from other tabs
    useEffect(() => {
        const storageHandler = (e) => {
            if (e.key === 'tb_rowsPerPage' && e.newValue) {
                setRowsPerPage(parseInt(e.newValue, 10));
                setActivePage(1);
            }
            if (e.key === 'tb_tableDensity' && e.newValue) {
                setTableDensity(e.newValue);
            }
        };
        window.addEventListener('storage', storageHandler);
        return () => window.removeEventListener('storage', storageHandler);
    }, []);

    return {
        rowsPerPage,
        tableDensity,
        activePage,
        setActivePage
    };
};

